import React from 'react';
import { useCartContext } from './context/CartContext';
import { Portal } from '../../components/portal/Portal';
import { CartProductNotAvailableAlert } from './components/CartProductNotAvailableAlert/CartProductNotAvailableAlert';
import { drawCart, setCartLoading } from '../legacyCart';
import { ShopifyStorefrontClient } from '../../api/shopify/ShopifyStorefrontClient';
import { transformStorefrontCartToJbCart } from './transformStorefrontCartToJbCart';

const storefrontClient = new ShopifyStorefrontClient();

export type CartAlertsProps = {
  cartAlertContainerClassName: string;
  isCartPage?: boolean;
};

export const CartAlerts = ({ cartAlertContainerClassName, isCartPage }: CartAlertsProps) => {
  const { cart } = useCartContext();
  const container = document.getElementsByClassName(cartAlertContainerClassName)?.[0] as HTMLElement | null | undefined;

  const handleOnClick = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, lineId: string) => {
    event.preventDefault();
    setCartLoading(true);

    const updatedCart = await storefrontClient.removeFromCart(lineId);
    await drawCart(transformStorefrontCartToJbCart(updatedCart));
  };

  const alerts = cart?.items
    ?.map(item => {
      if (item.isNoLongerAvailable) {
        return (
          <CartProductNotAvailableAlert
            key={item.sku}
            heading="Sorry, this product is no longer available."
            message="Please remove it to checkout."
            productImageUrl={item.image}
            productTitle={item.product_title}
            lineId={item.line_id}
            marketplaceSeller={item.properties?._marketplaceSeller}
            isCartPage={isCartPage}
            onClick={handleOnClick}
          />
        );
      }
      return null;
    })
    .filter(Boolean);

  return container ? <Portal container={container}>{alerts}</Portal> : null;
};
